module.exports = __webpack_public_path__ + "img/log-minus.f344c9f7.svg";